import styled from 'styled-components';

export const VirtualBackgroundsContainer = styled.section`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    gap: 8px;
    margin-top: 16px;
    width: 100%;
`;
